import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';

const FONT_BODY = { fontFamily: "'Crimson Text', Georgia, serif" };

export const DeleteEventDialog = ({ event, onClose, onConfirm }) => (
  <Dialog open={!!event} onOpenChange={(open) => !open && onClose()}>
    <DialogContent className="sm:max-w-md" data-testid="delete-event-dialog">
      <DialogHeader>
        <DialogTitle className="text-2xl text-red-700">Delete Event</DialogTitle>
        <DialogDescription style={FONT_BODY}>
          Are you sure you want to delete &quot;{event?.title}&quot;? This cannot be undone.
        </DialogDescription>
      </DialogHeader>
      <DialogFooter className="gap-2">
        <Button variant="outline" onClick={onClose} style={FONT_BODY}>Cancel</Button>
        <Button
          data-testid="confirm-delete-btn"
          onClick={() => onConfirm(event?.id)}
          className="bg-red-600 hover:bg-red-700 text-white font-semibold"
          style={FONT_BODY}
        >
          Delete
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
